import constants from '../constants';
import config from '../../config';

const { FALLBACK_SOURCE_LOCALE } = constants.common;

const getSupportedLocale = (locale) => {
  const supportedLocales = config.accessors.getSupportedLocales();
  const [langCode] = locale.split('-');
  const supportedLocale = supportedLocales.find((targetLocale) =>
    targetLocale.startsWith(langCode)
  );

  return supportedLocale || FALLBACK_SOURCE_LOCALE;
};

export default getSupportedLocale;
